import { DropdownMenu } from "./styles";

export const DropdownContent = ({ children, ...props }) => {
  return (
    <DropdownMenu container id="dropdown-content" {...props}>
      {children}
    </DropdownMenu>
  );
};
